import './styles/quasar.scss'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/mdi-v7'

import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';

// To be used on app.use(Quasar, { ... })
export default {
  // Quasar plugins
  plugins: {
    Notify,
    Dialog
  },
  config: {
    /* Notify defaults */
    notify: {
      position: 'top',
      timeout: 1000,
    },
  },
  extras: [
    'material-icons',
    'mdi-v7',
  ]
}